import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

const ReasonContainer = styled(Box)`
  width: 100%;

  > span {
    font-weight: bold;
  }

  @media only screen and (max-width: 992px) {
    border-top: 1px solid #cccaca;
    padding-top: 10px;
  }

  > ul {
    margin: 0px;
    padding: 0px;
    padding-left: 18px;
    font-size: 14px;
    color: #333;
    width: 95%;

    @media only screen and (max-width: 992px) {
      width: 85%;
    }
  }
`
export default ReasonContainer
